export const getUserContextProps = () => window?.SRI_STAFF_UI_CONTEXT?.props;
export const getUserContextPermissions = () => window?.SRI_STAFF_UI_CONTEXT?.permissions;
export const getUserContextToggles = () => window?.SRI_STAFF_UI_CONTEXT?.toggles;
export const getUserContextState = () => window?.SRI_STAFF_UI_CONTEXT?.state || null;
